module.exports = __webpack_public_path__ + "5e62759c9aaec726ee9e3120e4aabdfd.svg";